module.exports = __webpack_public_path__ + "static/media/electric-blue_thumb.dd14914e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colours/electric-blue_thumb.jpg
// module id = 129
// module chunks = 0